// extracted by mini-css-extract-plugin
export default {"title":"order-view_title__TETku","divider":"order-view_divider__Ztcq-"};